var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Link } from 'react-router-dom';
import DocumentTitle from 'react-document-title';
import Icon from 'antd/lib/icon';
import Layout from 'antd/lib/layout';
import 'antd/lib/layout/style/index.css';
import PageError from './components/PageError';
import PageWait from './components/PageWait';
import PageHeader from './components/PageHeader';
import PageFooter from './components/PageFooter';
var selfStyles = require('./Page.scss');
var Page = (function (_super) {
    __extends(Page, _super);
    function Page(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isShowingAside: false,
        };
        _this.toggleAside = _this.toggleAside.bind(_this);
        return _this;
    }
    Page.prototype.toggleAside = function () {
        this.setState({
            isShowingAside: !this.state.isShowingAside,
        });
    };
    Page.prototype.render = function () {
        var documentTitle = Page.appName + " | Live scores and results for climbing events";
        if (this.props.documentTitle) {
            documentTitle = this.props.documentTitle + " | Live scores and results | Powered by " + Page.appName;
        }
        else if (this.props.pageTitle) {
            documentTitle = this.props.pageTitle + " | Live scores and results | Powered by " + Page.appName;
        }
        var pageContent;
        if (this.props.isWaiting) {
            pageContent = React.createElement(PageWait, { waitMessage: this.props.waitMessage });
        }
        else if (this.props.isError) {
            pageContent = React.createElement(PageError, { errorTitle: this.props.errorTitle, errorMessage: this.props.errorMessage });
        }
        else {
            var pageStyle = this.props.pageContentMaxWidth !== undefined
                ? { maxWidth: this.props.pageContentMaxWidth, margin: '0 auto' }
                : {};
            var pageNavigate = this.props.pageNavigateLink && (React.createElement(Link, { to: this.props.pageNavigateLink, className: selfStyles.pageNavigate },
                React.createElement(Icon, { type: 'left' }),
                " ",
                this.props.pageNavigateText));
            pageContent = (React.createElement(Layout.Content, { className: selfStyles.mainContent },
                React.createElement("div", { style: pageStyle },
                    pageNavigate,
                    React.createElement("div", { className: selfStyles.mainContentTop },
                        React.createElement("div", { className: selfStyles.mainContentTitle }, this.props.pageTitle && React.createElement("h1", { className: selfStyles.pageTitle }, this.props.pageTitle)),
                        this.props.pageAction && (React.createElement("div", { className: selfStyles.mainContentActions }, this.props.pageAction))),
                    this.props.children)));
        }
        return (React.createElement(DocumentTitle, { title: documentTitle },
            React.createElement(React.Fragment, null,
                React.createElement(Layout, { className: selfStyles.screen },
                    React.createElement(Layout, { className: selfStyles.main }, pageContent),
                    React.createElement(PageHeader, { toggleAside: this.toggleAside })),
                React.createElement(PageFooter, null))));
    };
    Page.appName = process.env.NODE_ENV === 'development'
        ? 'CRIMP.dev'
        : process.env.REACT_APP_DEPLOY_ENV === 'staging'
            ? 'PINCH'
            : 'CRIMP';
    Page.defaultProps = {
        isWaiting: false,
        isError: false,
    };
    return Page;
}(React.Component));
export default Page;



//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/Page.tsx
// module id = 614
// module chunks = 0